import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import "../Asociados/createAsociados.css";
import "./createOrden.css";

import "./../formsCommons.css";

const ErrorModal = forwardRef(
  ({ item, returnToModalId, infoText, infoTitle, customId }, ref) => {
    const modalRef = useRef();
    const dismissBtnRef = useRef();

    const staticBackdropErrorModal = `staticBackdropErrorModal${customId}`;

    const staticBackdropErrorModalHash = `#${staticBackdropErrorModal}`;
    const staticBackdropErrorModalLabel = `${staticBackdropErrorModal}Label`;

    const targetReturnToModalId = `#${returnToModalId}`;

    useEffect(() => {
      console.log("---> change item: " + item);

      /*
      const [promocion, setPromocion] = useState(null);
          value < item.producto.precio * 0.01 ||
                                      value >= item.producto.precio * 0.9
      */

      //  refAutocompleteProducto.current.clearInput();

      if (item == null) {
        return;
      }

      loadItem(item);
    }, [item]);

    useEffect(() => {}, []);

    useImperativeHandle(ref, () => ({
      getValue: () => {
        return 0;
      },
      toggleModal: () => {
        modalRef.current.click();
      },
    }));

    function loadItem(newItem) {
      //  setPromocion(promocion);

      //-
      /*  let aValuePercent = 40; // enviar el valor de descuento en ventainterna
      if (
        !(
          newItem &&
          newItem?.promocion?.id === PROMOCIONES_STATES.VENTA_INTERNA.id
        )
      ) {
        setValuePercent(aValuePercent);
      }*/
      //-
      const isEmpty = newItem && Object.keys(newItem).length === 0;
      if (isEmpty) {
        return;
      }
    }

    function handleSubmit(event) {
      event.preventDefault();
    }

    return (
      <>
        <button
          ref={modalRef}
          type="button"
          className="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target={staticBackdropErrorModalHash}
          hidden
        >
          Abrir Crear Orden
        </button>

        <div
          className="modal fade modal-lg"
          id={staticBackdropErrorModal}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby={staticBackdropErrorModalLabel}
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id={staticBackdropErrorModalLabel}>
                  {infoTitle}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  data-bs-toggle="modal"
                  data-bs-target={targetReturnToModalId}
                  aria-label="Close"
                ></button>
              </div>

              <div
                className="modal-body"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <form className="row g-3" onSubmit={handleSubmit}>
                  <div className="form-control" style={{ border: "none" }}>
                    <div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        {infoText}
                      </label>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-toggle="modal"
                      data-bs-dismiss="modal"
                      data-bs-target={targetReturnToModalId}
                    >
                      Cancelar
                    </button>
                    <button
                      ref={dismissBtnRef}
                      className="btn btn-primary"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-dismiss="modal"
                      data-bs-target={targetReturnToModalId}
                      hidden
                    ></button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  },
);

export default ErrorModal;
